import { PlanDetails } from "~data/PlanDetails";

import { ContainsAllCheck } from "../../../../../api/src/utils/validators";

export function planMonthsInPeriod(period: PlanDetails["period"]): number {
  switch (period) {
    case "year":
      return 12;
    case "month":
      return 1;
    case "quarter":
      return 3;
    case "six_month":
      return 6;
    case "two_month":
      return 2;
  }
}

export const FEATURES = [
  "helloscreen_extension",
  "helloscreen_presentation_sharing",
  "activity_log",
  "cobrowse",
  "cobrowse_web_sdk",
  "cobrowse_native_sdk",
  "cobrowse_agent_notes",
  "cobrowse_agent_redirect",
  "cobrowse_agent_request_button",
  "cobrowse_agent_share_screen",
  "cobrowse_audio_calls",
  "cobrowse_dev_console",
  "cobrowse_dev_console_control",
  "cobrowse_multi_agent",
  "cobrowse_remote_control",
  "cobrowse_rest_api",
  "cobrowse_session_history",
  "cobrowse_session_history_own",
  "cobrowse_session_recording",
  "cobrowse_user_full_screen",
  "cobrowse_whitelabel",
  "cobrowse_visitor_session_feedback",
  "helloscreen_document_share",
  "helloscreen_document_share_templates",
  "helloscreen_extension_full_screen",
  "helloscreen_extension_multi_viewer",
  "helloscreen_extension_request_viewer_screen",
  "helloscreen_extension_url_whitelist",
  "intercom_session_summary",
  "livedocument_templates",
  "reporting",
  "salesforce_integration",
  "sso",
  "user_roles",
  "userview_screen_tv",
  "cobrowse_browsing_history",
  "cobrowse_browsing_history_automatic_screenshots",
  "zapier_integration",
] as const;
const allFeaturesCheck: ContainsAllCheck<(typeof FEATURES)[number], PlanDetails["features"][number]> = true;

export const PRODUCTS = ["helloscreen", "cobrowsingapi", "userview", "livedocument"] as const;
const allProductsCheck: ContainsAllCheck<(typeof PRODUCTS)[number], PlanDetails["product"]> = true;

export const PLAN_PERIODS = ["year", "month", "quarter", "six_month", "two_month"] as const;
const allPeriodsCheck: ContainsAllCheck<(typeof PLAN_PERIODS)[number], PlanDetails["period"]> = true;
